import useAuth from "hooks/useAuth";
import Button from "components/Button/Button";
import React, { useEffect, useState } from "react";
import { AiOutlineLogout } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import ProfileLayout from "components/Layout/ProfileLayout";
import { ProfileCard } from "components/Card/ProfileCard";
import actionApi from "services/actionApi";
import LogoutModal from "components/Modal/LogoutModal";
import ProfileData from "components/Section/ProfileData";
import useAppStore from "store/useAppStore";

const ProfilePage = () => {
  const { doLogout } = useAuth();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [profile, setProfile] = useState({});
  const { setName } = useAppStore();

  useEffect(() => {
    actionApi
      .getProfile()
      .then((response) => {
        setProfile(response?.data);
        setName(response?.data?.name);
      })
      .catch()
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const handleLogout = () => {
    doLogout();
    navigate("/login");
  };

  return (
    <ProfileLayout profile={profile}>
      <LogoutModal
        open={showModal}
        onClose={() => setShowModal(false)}
        handleLogout={handleLogout}
      />
      <ProfileCard className={"flex flex-col gap-8"}>
        <div className="flex justify-between items-center">
          <span className="sm:text-2xl font-medium text-wce-navy">
            Your Profile
          </span>
          <div>
            <Link to={"/profile/edit"}>
              <Button size="large" variant="secondary" rounded>
                Edit Profile
              </Button>
            </Link>
          </div>
        </div>
        {isLoading ? "" : <ProfileData profile={profile} />}
        <div className="mt-auto self-end">
          <Button
            className="flex items-center gap-2"
            size="large"
            color="danger"
            variant="secondary"
            rounded
            onClick={() => setShowModal(true)}
          >
            <AiOutlineLogout />
            Log Out
          </Button>
        </div>
      </ProfileCard>
    </ProfileLayout>
  );
};

export default ProfilePage;
